<template>
<modal title="New Product Distribution">
  <form>
    <div class="columns">
      <div class="column">
        <data-selector
          required
          :items="distributions"
          disabled
          :error="$root.errors.distribution_id"
          v-model="distribution.distribution_id"
          value-key="id"
          label-key="name">Distribution</data-selector>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <text-input required :error="$root.errors.identifier" v-model="distribution.identifier">Indentifier</text-input>
      </div>
      <div class="column">
        <text-input v-model="distribution.version_retriever">Version Retriever</text-input>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <submit-button :working="working" class="is-rounded" @submit="saveDistribution">Save</submit-button>
      </div>
    </div>
  </form>
</modal>  
</template>
<script>
import { getPath } from '@/api/common'
import { mapGetters } from 'vuex'

export default {

  props: {
    distro: {
      type: Object,
      default: () => ({
        distribution_id: '',
        identifier: '',
        version_retriever: ''
      })
    }
  },

  data: () => ({
    distributions: [],
    distribution: {
      distribution_id: '',
      identifier: '',
      version_retriever: ''
    },
    working: false
  }),

  created() {
    this.distribution.distribution_id = this.distro.id
    this.distribution.identifier = this.distro.distribution.identifier
    this.distribution.version_retriever = this.distro.distribution.version_retriever
    getPath({
      path: 'api/super/distribution-list'
    }, ({data}) => this.distributions = data, error => {})
  },

  methods: {
    saveDistribution() {
    this.$store.dispatch('software/updateDistribution', {
        softwareId: this.software.id,
        ...this.distribution
      }).then(() => {
        this.$toast.success('Saved')
        this.$close(false)
      }).catch(() => {
        this.$toast.error('Whoops')
      })
    }
  },

  computed: mapGetters('software', [
    'software'
  ])

}
</script>